import React, { useEffect } from 'react';
import Hero from '../../components/hero/hero';
import Layout from '../../components/layout/layout';

import styles from "./style.module.scss";
import { BASENAME } from "../../constant";


export default function Terms() {

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://cdn.iubenda.com/iubenda.js';
        script.async = true;
        document.body.appendChild(script);
        return () => { document.body.removeChild(script); };
    }, []);

    return (
        <Layout>
            <Hero
                image={"bg_hero_brands.png"}
                title={"Termini e condizioni"}
                                breadcrumb={[
                    { label: "Home", link: BASENAME },
                    { label: "Termini e condizioni", link: null }
                ]}

            />
            <section>
                <div className="container">
                    <a href="https://www.iubenda.com/termini-e-condizioni/29122716" className="iubenda-nostyle no-brand iubenda-embed iub-no-markup iub-body-embed" title="Termini e Condizioni">Termini e Condizioni</a>
                </div>
            </section>

        </Layout>


    );
}

